import React, { useMemo } from "react";
import host from "../../global";
import { ROUNDS } from "../../constants/secondaryCamera";
import {
  CONSENT_ITEMS,
  PROCTORING_INSTRUCTIONS,
} from "../../constants/interviewInstructions";
import PreInterviewCheck from "./PreInterviewCheck";

// The technical-interview flavour of the shared pre-check flow. Everything
// visual and every device check lives in PreInterviewCheck; this file only
// describes what makes an interview an interview.
const InterviewInstructions = () => {
  const config = useMemo(
    () => ({
      round: ROUNDS.INTERVIEW,
      railTitle: "Pre-interview check",
      consentItems: CONSENT_ITEMS,
      instructions: PROCTORING_INSTRUCTIONS,

      // Interviews always go fullscreen, and count down before handing off.
      useCountdown: true,
      shouldGoFullscreen: () => true,
      hasReadyStep: false,

      ready: {
        startButtonLabel: "Start Interview",
      },

      proceedErrorMessage:
        "Failed to start the interview. Please try again or contact support.",

      onProceed: async ({
        interviewId,
        navigate,
        hasActiveStream,
        permissionsGranted,
        isLiveAvatarEnabled,
      }) => {
        // LiveAvatar handles greeting and all audio itself — skip greet/thank.
        if (isLiveAvatarEnabled) {
          navigate(`/candidate/live-avatar-interview/${interviewId}`);
          return;
        }

        const candidateToken = sessionStorage.getItem(`candidateToken_${interviewId}`);
        const authHeaders = {
          "Content-Type": "application/json",
          ...(candidateToken ? { Authorization: `Bearer ${candidateToken}` } : {}),
        };

        const greetResponse = await fetch(`${host}/greet_user/${interviewId}`, {
          method: "POST",
          headers: authHeaders,
        });
        if (greetResponse.status === 401) {
          navigate(`/candidate/${interviewId}/scheduletest`, { replace: true });
          return;
        }
        if (!greetResponse.ok) throw new Error("Failed to greet user");

        const thankResponse = await fetch(`${host}/thank_user/${interviewId}`, {
          method: "POST",
          headers: authHeaders,
        });
        if (thankResponse.status === 401) {
          navigate(`/candidate/${interviewId}/scheduletest`, { replace: true });
          return;
        }
        if (!thankResponse.ok) throw new Error("Failed to thank user");

        navigate(`/candidate/interview/${interviewId}`, {
          state: {
            streamHandoff: hasActiveStream,
            permissionsGranted,
            timestamp: Date.now(),
          },
        });
      },
    }),
    []
  );

  return <PreInterviewCheck config={config} />;
};

export default InterviewInstructions;
